import request from './request.js'

export default {
  /** 编码 */
  urlencode (str) {
    str = (str + '').toString()
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28')
      .replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+')
  },
  /** 授权登录 */
  returnWXAuthorization () {
    const url = window.location.href
    console.log(url)
    console.log(url.indexOf('test'))
    const appid = 'wx7cfd35312378d9fa'
    // eslint-disable-next-line camelcase
    let redirect_uri = ''
    if (url.indexOf('test') < 0) {
      // eslint-disable-next-line camelcase
      redirect_uri = this.urlencode('http://wcs.soqp.cn/confirm')
    } else {
      // eslint-disable-next-line camelcase
      redirect_uri = this.urlencode('http://testwcs.soqp.cn/confirm')
    }
    // eslint-disable-next-line camelcase
    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
  },
  /** 数值单位换算 */
  unitConversion (num) {
    if (!num || isNaN(num)) {
      return 0
    }
    num = Number(num)
    if (Math.abs(num) >= 100000000) {
      return (num / 100000000).toFixed(2) + '亿'
    } else if (Math.abs(num) >= 10000) {
      return (num / 10000).toFixed(2) + '万'
    } else {
      return num.toFixed(2)
    }
  },
  /**
   * 格式化数字
   */
  numberFormat (cellValue) {
    if (!cellValue) {
      return 0
    }
    cellValue = cellValue.toFixed(2)
    cellValue += ''
    if (!cellValue.includes('.')) {
      cellValue += '.'
    }
    return cellValue.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) { return $1 + ',' }).replace(/\.$/, '')
  },
  /** 分割数值 */
  segmentsNum (num) {
    if (!num) {
      return 0
    }
    // 取整
    let intPart = parseInt(num)
    // 分割
    let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    let floatPart = '.00'
    let value2Array = num.toString().split('.')
    if (value2Array.length === 2) {
      floatPart = value2Array[1].toString()
      if (floatPart.length === 1) {
        return intPartFormat + '.' + floatPart + '0'
      } else {
        return intPartFormat + '.' + floatPart
      }
    } else {
      return intPartFormat + floatPart
    }
  },
  /** 分割整数 */
  segmentsInt (num) {
    if (!num) {
      return 0
    }
    // 取整
    let intPart = parseInt(num)
    // 分割
    let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    return intPartFormat
  },
  // 日期补0
  formatDate (str) {
    // 根据 - 符号拆分
    return str.split('-').map((item) => {
      // +item 将item字符串转换为数字
      // 小于10的时候就补全一个前缀0
      if (+item < 10) {
        return '0' + +item
      }
      // 大于10的时候不用补0
      return item
    }).join('-') // 最后重组回来
  },
  /** 菜单访问日志 */
  getMenuLog (id) {
    request({
      url: `/basedata/v1/menu/addMenuLog/` + id,
      method: 'post'
    }).then(res => {
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/index.js